import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuccessComponent } from './success.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@presentation/view/shared/shared.module';
import { AppMaterialModule } from 'src/app/app-material.module';
import { LottieModule } from 'ngx-lottie';

export function playerFactory() {
  return import('lottie-web');
}

@NgModule({
  declarations: [SuccessComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    AppMaterialModule,
    SharedModule,
    LottieModule.forRoot({ player: playerFactory }),
  ]
})
export class SuccessModule { }
